<template>
    <div class="bg-white p-3 rounded">
        <div>
            <div>
                <kt-row>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="settlement_id">
                                {{ $t('label.settlement_id') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="settlement_id"
                                    name="settlement_id"
                                    disabled
                                    class="en_num"
                                    :value="form_data.settlement_id"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('label.status') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="status"
                                    name="status"
                                    disabled
                                    :value="getStatusSrt(form_data.status)"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="created_at">
                                {{ $t('label.date_created') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="created_at"
                                    name="created_at"
                                    disabled
                                    :value="form_data.created_at"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="payment_date">
                                {{ $t('label.date_payed') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="payment_date"
                                    name="payment_date"
                                    disabled
                                    :value="form_data.payment_date"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="amount">
                                {{ $t('label.settlement_amount') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="amount"
                                    name="amount"
                                    disabled
                                    :value="form_data.amount"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="wage_bank">
                                {{ $t('label.transaction_wage_bank') + ' (' +  $t('label.rial') + ')' }}
                            </kt-form-label>
                            <kt-form-control
                                    id="wage_bank"
                                    name="wage_bank"
                                    disabled
                                    :value="form_data.wage_bank"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="psp">
                                {{ $t('label.psp') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="psp"
                                    name="psp"
                                    disabled
                                    :value="form_data.psp"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="sheba_number">
                                {{ $t('label.sheba_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="sheba_number"
                                    name="sheba_number"
                                    disabled
                                    class="en_num"
                                    :value="form_data.sheba_number"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12"  v-if="$can('read', 'settlement')">
                        <kt-form-group>
                            <kt-form-label for="wage">
                                {{ $t('label.wage') }}
                            </kt-form-label>
                            <kt-form-control
                                id="wage"
                                name="wage"
                                disabled
                                class="wage"
                                :value="form_data.wage"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="gateway_id">
                                {{ $t('label.gateway_id') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="gateway_id"
                                    name="gateway_id"
                                    disabled
                                    class="en_num"
                                    :value="form_data.gateway_id"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="gateway_farsi_name">
                                {{ $t('label.gateway_farsi_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="gateway_farsi_name"
                                    name="gateway_farsi_name"
                                    disabled
                                    :value="form_data.gateway_farsi_name"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="bank_reference">
                                {{ $t('label.bank_reference') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="bank_reference"
                                    name="bank_reference"
                                    disabled
                                    :value="form_data.bank_reference"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </div>
        </div>
        <div v-if="form_data.details.length != 0">
            <div>
                <h5 class="mb-4">{{ $t('label.payment_details') }}</h5>
                <table class="table table-striped table-cards-mobile" style="font-size: 0.89rem;">
                    <thead>
                    <tr>
                        <td>{{ $t('label.amount') + ' (' + $t('currency.rial') + ')' }}</td>
                        <td>{{ $t('label.sheba_number') }}</td>
                        <td>{{ $t('label.payee_name') }}</td>
                        <td>{{ $t('label.bank_tracking_number') }}</td>
                        <td>{{ $t('label.status') }}</td>
                        <td>{{ $t('datatable.actions') }}</td>
                    </tr>
                    </thead>
                    <tbody style="white-space: nowrap;">
                    <tr
                            v-bind:key="index"
                            v-for="(detail, index) in form_data.details"
                    >
                        <td :data-label="$t('label.amount') + ' (' + $t('currency.rial') + ')'">{{ detail.amount }}</td>
                        <td class="en_num" :data-label="$t('label.sheba_number')">{{ detail.sheba_number }}</td>
                        <td :data-label="$t('label.payee_name')">{{ detail.full_name }}</td>
                        <td :data-label="$t('label.bank_tracking_number')">{{ detail.tracking_number }}</td>
                        <td :data-label="$t('label.status')"><div :class="getStatusColor(detail.status)">{{ getStatusSrt(detail.status) }}</div></td>
                        <td :data-label="$t('datatable.actions')">
                            <div class="dropdown">
                                <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown" data-target="#myModal">
                                    <i class="fa fa-cog"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <h5 class="dropdown-header">{{ $t('label.change_status_to') }}</h5>
                                    <button
                                            id="change_status_btn"
                                            v-for="(status, index) in getDetailStatuses(detail.status)"
                                            @click="changeDetailStatus(detail.id, status.int)"
                                            class="dropdown-item"
                                            v-bind:key="index"
                                    >
                                        {{ status.str }}
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import { statusStr } from '@/constants/settlementStatus'
    import {settlementStatus} from "@/constants/settlementStatus";
    import { settlementService } from '@/common/api.service'
    import commonAccessColumns from "../../transaction/datatable/commonAccessColumns";
    import { AuthorizationHeader } from '@/common/jwt.service'
    import { ApiUrl } from '@/common/api.service'
    import { i18n } from '@/plugins/i18n'
    import toastr from 'toastr'

    export default {
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-top-left",
                    preventDuplicates: false,
                    rtl: false
                }
                return toastr
            }
        },
        props: {
            form_data: {
                required: true,
            }
        },
        methods: {
            getStatusSrt(status_int){
                return statusStr.get(status_int)
            },
            getStatusColor(status_int){
                if(status_int === settlementStatus.CREATED) {
                    return 'color-blue'
                }

                if(status_int === settlementStatus.SENT_TO_SHAPARAK) {
                    return 'color-orange'
                }

                if(status_int === settlementStatus.ACCEPTED || status_int === settlementStatus.FINAL_PAYED) {
                    return 'color-green'
                }

                if(status_int === settlementStatus.REJECTED) {
                    return 'color-red'
                }
            },
            getDetailStatuses(current_status) {
                let statuses = []

                for (let i = 0; i < 5; i++) {
                    if (current_status !== i) {
                        statuses.push({
                            int: i,
                            str: statusStr.get(i)
                        })
                    }
                }
                return statuses
            },
            changeDetailStatus(detail_id, status) {
                settlementService.changeDetailStatus(detail_id, status).then(response => {
                    this.toastr.success(i18n.t('settlement.change_succeeded'))
                }).catch(({response}) => {
                    this.toastr.fail(i18n.t('settlement.change_failed'))
                })
            }
        }
    }
</script>

<style>
    .color-red {
        color: red;
    }
    .color-green {
        color: #57c974;
    }
    .color-blue {
        color: #0f9af0;
    }
    .color-orange {
        color: #ff8b33;
    }
</style>